import { interval, from } from 'rxjs';
import { take, startWith, switchMap, filter } from 'rxjs/operators';

import request from '@utils/axiosWrapper';
import { getStorage, setStorage } from '@utils/localStorage';
import * as Ids from '@utils/ids';

import store from '../../../../store';

const POLLING_INTERVAL = 60 * 60 * 1000;

const wmPoiId = Ids.getWmPoiId();
const cacheKey = `compensateProtocolSignedFor${wmPoiId}`;
const checkDateCacheKey = `compensateProtocolCheckDayFor${wmPoiId}`;

/**
 * 非SLA商家7折赔付留痕
 *
 * 前端判断： 1. 是否为高峰期 2. 每小时轮询接口(考虑到页面常驻可能会跨夜)
 * 后端判断： 1. 是否同一天内第一次展示弹框 2. 展示三次后自动签署
 * 接口文档： https://km.sankuai.com/page/199491114
 */
const init = () => {
    if (!wmPoiId || wmPoiId === '-1') {
        // 仅单店展示
        return;
    }

    const compensateProtocolSigned = getStorage(cacheKey);
    const lastCheckDate = getStorage(checkDateCacheKey);

    if (compensateProtocolSigned === 'true' || lastCheckDate === `${new Date().getDate()}`) {
        // 当前门店已经签署协议 or 当前门店当天已经提示过
        return;
    }

    interval(POLLING_INTERVAL)
        .pipe(
            startWith(null),
            filter(() => {
                const date = new Date();
                const hour = date.getHours();
                /** 此时间段内为高峰期 */
                const isBusy = (hour >= 10 && hour < 14) || (hour >= 17 && hour < 20);
                return !isBusy; // 仅非高峰期检查
            }),
            switchMap(() => {
                return from(
                    request
                        .get<{ signStatus: boolean; displayStatus: boolean }>(
                            '/api/poi/r/poi/compensate/protocol',
                        )
                        .then(
                            res => {
                                return res;
                            },
                            () => null,
                        ),
                );
            }),
            filter(res => res !== null),
            take(1),
        )
        .subscribe(res => {
            setStorage(checkDateCacheKey, `${new Date().getDate()}`); // 更新检查日期
            if (res!.displayStatus) {
                // 弹框
                store.dispatch({
                    type: 'shellCommon/changeCompensateProtocolModalVisibility',
                    payload: true,
                });
                // 上报展示
                request.postAsFormSubmit('/api/poi/w/poi/compensate/protocol', { signStatus: 0 });
            } else if (res!.signStatus) {
                // 已经签署过，存储在本地
                setStorage(cacheKey, 'true');
            }
        });
};

export default { init };
